import { ref, computed } from '@vue/composition-api'
import store from '@/store'

export default function useVerticalNavMenu(props) {
  // ------------------------------------------------
  // isVerticalMenuCollapsed
  // ------------------------------------------------
  const isVerticalMenuCollapsed = computed({
    get: () => store.state.verticalMenu.isVerticalMenuCollapsed,
    set: val => {
      store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', val)
    },
  })

  const isVerticalMenuActive = computed({
    get: () => store.state.verticalMenu.isVerticalMenuActive,
    set: val => {
      store.commit('verticalMenu/UPDATE_VERTICAL_MENU_ACTIVE', val)
    },
  })

  const isMobile = computed({
    get: () => store.state.verticalMenu.isMobile,
    set: val => {
      store.commit('verticalMenu/UPDATE_MOBILE', val)
    },
  })

  // ------------------------------------------------
  // collapseTogglerIcon
  // ------------------------------------------------
  const collapseTogglerIcon = computed(() => {
    if (props.isVerticalMenuActive) {
      return isVerticalMenuCollapsed.value ? 'unpinned' : 'pinned'
    }
    return 'close'
  })

  const isMouseHovered = ref(false)

  const updateMouseHovered = val => {
    isMouseHovered.value = val
  }

  const toggleCollapsed = () => {
    isVerticalMenuCollapsed.value = !isVerticalMenuCollapsed.value
  }

  const collapse = (value) =>{
    isVerticalMenuCollapsed.value = value
  }

  return {
    isMouseHovered,
    isVerticalMenuCollapsed,
    isVerticalMenuActive,
    collapseTogglerIcon,
    isMobile,
    toggleCollapsed,
    collapse,
    updateMouseHovered,
  }
}
